(() => {
  let el = null;
  let container = null;
  let originalOffset = null;
  let ticking = false;
  let lastScrollY = window.scrollY;
  let isBottomLocked = false;

  function isDesktop() {
    return window.innerWidth >= 1024;
  }

  function clearDesktopLockStyles() {
    el.style.removeProperty("position");
    el.style.removeProperty("top");
    el.style.removeProperty("bottom");
  }

  function applyDesktopBottomLock(containerBottom, elHeight, scrollY) {
    const top = containerBottom - scrollY - elHeight;
    el.style.setProperty("position", "fixed", "important");
    el.style.setProperty("top", `${top}px`, "important");
    el.style.setProperty("bottom", "auto", "important");
  }

  function updateStickState() {
    if (!el || !container) {
      ticking = false;
      return;
    }

    // On mobile, don't apply stuck as it's always fixed to the bottom.
    if (!isDesktop()) {
      el.classList.remove("stuck");
      el.classList.remove("stuck-bottom");
      clearDesktopLockStyles();
      isBottomLocked = false;
      ticking = false;
      return;
    }

    if (originalOffset === null) {
      originalOffset = el.offsetTop;
    }

    const scrollY = window.scrollY;
    const isScrollingUp = scrollY < lastScrollY;
    const containerBottom = container.offsetTop + container.offsetHeight;
    const elHeight = el.offsetHeight;
    const hasReachedBottom = scrollY + elHeight >= containerBottom;

    // Keep the control bottom-locked until scroll direction changes.
    if (isBottomLocked) {
      if (isScrollingUp) {
        isBottomLocked = false;
        el.classList.remove("stuck-bottom");
        clearDesktopLockStyles();
      } else {
        el.classList.add("stuck");
        el.classList.add("stuck-bottom");
        applyDesktopBottomLock(containerBottom, elHeight, scrollY);
        lastScrollY = scrollY;
        ticking = false;
        return;
      }
    }

    if (!isScrollingUp && hasReachedBottom) {
      isBottomLocked = true;
      el.classList.add("stuck");
      el.classList.add("stuck-bottom");
      applyDesktopBottomLock(containerBottom, elHeight, scrollY);
    } else if (scrollY > originalOffset && !hasReachedBottom) {
      el.classList.add("stuck");
      el.classList.remove("stuck-bottom");
      clearDesktopLockStyles();
    } else {
      el.classList.remove("stuck");
      el.classList.remove("stuck-bottom");
      clearDesktopLockStyles();
    }

    lastScrollY = scrollY;
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    window.requestAnimationFrame(updateStickState);
    ticking = true;
  }

  function initStickyFilters() {
    el = document.querySelector(".sticky-buttons__wrapper");
    container = document.querySelector(".js-collection-main-content");
    originalOffset = null;
    isBottomLocked = false;
    lastScrollY = window.scrollY;
    if (el) {
      el.classList.remove("stuck");
      el.classList.remove("stuck-bottom");
      clearDesktopLockStyles();
    }
    updateStickState();
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", initStickyFilters);
  document.addEventListener("DOMContentLoaded", initStickyFilters);
  document.addEventListener("shopify:section:load", initStickyFilters);

  // In case the script runs after DOM is already parsed.
  if (document.readyState !== "loading") {
    initStickyFilters();
  }
})();